export default "__VITE_ASSET__D9ZDkn8$__"